import React, { Fragment } from 'react'
import { getPrintableTime } from 'lib/datetime'
import { Row, Cell } from 'components/Table'
import { getMessage } from 'lib/translator'
import { Link } from 'react-router-dom'
import './style.scss'

const tableHeaders = [
  getMessage('offer.offerIdsConfig.offer.id'),
  getMessage('offer.offerIdsConfig.offer.description'),
  getMessage('offer.offerIdsConfig.offer.validFrom'),
  getMessage('offer.offerIdsConfig.offer.validTill'),
  getMessage('offer.offerIdsConfig.offer.sapReference'),
  getMessage('offer.offerIdsConfig.offer.status'),
  '',
]

const OfferTableProperties = (_history) => {
  return {
    headers: tableHeaders,
    row: ({
      id,
      offerValidFrom,
      offerValidTill,
      description,
      storeId,
      status,
      metaData,
    }) => {
      const getDate = (dateTime) =>
        dateTime && getPrintableTime(dateTime).split(', ')[0]
      const getTime = (dateTime) =>
        dateTime && getPrintableTime(dateTime).split(', ')[1]

      const numberOfStores = storeId?.split(',').length

      return (
        <Fragment>
          <Row className="offer-ids-config-table-row" key={`row-${id}`}>
            <Cell className="offer-id">
              <div className="vertical-col">
                <div className="id-field">{id}</div>
                <div className="text-muted">{numberOfStores} stores</div>
              </div>
            </Cell>

            <Cell className="description">{description}</Cell>

            <Cell className="valid-from-date-time">
              <div>{getDate(offerValidFrom)}</div>
              <div className="time text-muted">{getTime(offerValidFrom)}</div>
            </Cell>

            <Cell className="valid-till-date-time">
              <div>{getDate(offerValidTill)}</div>
              <div className="time text-muted">{getTime(offerValidTill)}</div>
            </Cell>

            <Cell className="sap-reference">{metaData?.sapReference}</Cell>

            <Cell className="status">{status}</Cell>

            <Cell className="more-details">
              <Link
                className="button secondary"
                to={`/marketing/offers/edit/${id}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Details
              </Link>
            </Cell>
          </Row>
        </Fragment>
      )
    },
  }
}

export default OfferTableProperties
